import React, { Component } from 'react';


class Hi extends Component{


	render(){
		return(
			<div>

				<div> 
					<div>
						<div className="mid-and-center"><h1 className='beast-text'>Rishi Karri</h1> </div>


						<div className='animation-container'>
  

						    <span className='rectangleAnimation'> 
						      <div id="divAnimationBlock1"></div> 
						      <div id="divAnimationBlock2"></div> 
						      <div id="divAnimationBlock3"></div> 
						      <div id="divAnimationBlock4"></div> 

						      <div id="hi-animation-block">
						        <div id="h-animation-block">
						          <div id="h-1Block"></div> 
						          <div id="h-2Block"></div>
						          <div id="h-3Block"></div> 
						        </div>

						        <div id='i-animation-block'>
						          <div id="i-1-block"></div> 
						        </div>
						      </div>

						        
						      <div id="divAnimationBlock5"></div> 
						      <div id="divAnimationBlock6"></div> 						      
						       
						      <div id="divAnimationBlock7"></div> 
						      <div id="divAnimationBlock8"></div> 
						      <div id="divAnimationBlock9"></div> 
						      <div id="divAnimationBlock10"></div> 
						      <div id="divAnimationBlock11"></div> 
						      <div id="divAnimationBlock12"></div> 
						      <div id="divAnimationBlock13"></div> 
						      <div id="divAnimationBlock14"></div> 
						      <div id="divAnimationBlock15"></div> 
						      <div id="divAnimationBlock16"></div> 
						      <div id="divAnimationBlock17"></div> 
						      <div id="divAnimationBlock18"></div> 
						      <div id="divAnimationBlock19"></div> 
						      <div id="divAnimationBlock20"></div> 
						      <div id="divAnimationBlock21"></div> 						      
						      
						  </span>
						</div>




						<div className='weakly-beast-text'>Software Developer</div> 

						{/* <div style={{marginTop: 20}} className='weakly-beast-text'>Atlanta, GA</div> 																 */}
						
						{/* <div style={{marginTop: 20}} className='weakly-beast-text'>Songwriter</div> 									

						<div style={{marginTop: 20}} className='weakly-beast-text'>Human</div> 									 */}
						
						{/* <div className='weak-beast-text'>Atlanta, Georgia </div> 									 */}
						
					</div>
				</div>				


			</div>

		)
	}
}

export default Hi;

// <div className='weakest-beast-text'>(Please Note: this website is stil under construction!) </div> 									